// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c39cb5d1c80d3475ab73900ad0b131bfa0849bd9.chunk.bundle.js";
};